import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;


export class editorialInsights_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected brandSegmentsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected primaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected datesFilter: filterDate_template;
    protected dimensionGrouping : multipleSelector_template;
    protected exportEditorialInsightsDataCsv: exportDataCsv;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    public toolTipActiveSess: infoButton_template;
    public toolTipActiveSessArt: infoButton_template;
    public toolTipFailure: infoButton_template;
    public toolTipSuccess: infoButton_template;


    static dimensionGroupingItems : Array<{id : string, name : string, backendName: string, displayName:string }> = [
        { "id": "dateData",  "name": "Day", "backendName": "Day", "displayName" : "dateData"},
        { "id": "monthYear",  "name": "Month", "backendName": "monthYear", "displayName" : "dateData"},
        { "id": "idBrand",  "name": "Brand", "backendName": "brand", "displayName" : "brandShortName"},
        { "id": "idSegment",  "name": "Segment", "backendName": "segmentName", "displayName" : "segmentName"},
        { "id": "idInitiative",  "name": "Mapping", "backendName": "initiative", "displayName" : "initiativeName"},
        { "id": "idPostPaymentCategorySystem",  "name": "System", "backendName": "systemName", "displayName" : "postPaymentCategorySystemName"},
        { "id": "idPrimaryCategory",  "name": "Primary Category", "backendName": "primary_category", "displayName" : "primaryCategoryName"},
        { "id": "idIntent",  "name": "Intent", "backendName": "intent", "displayName" : "intentName"},
        { "id": "idContentType",  "name": "Content Type", "backendName": "content_type", "displayName" : "contentTypeName"},
        { "id": "idNetworkCategory",  "name": "Network Category", "backendName": "network_category", "displayName" : "networkCategoryName"},
        { "id": "idEditor",  "name": "Sr Editor", "backendName": "sr_editor", "displayName" : "editorName"},
        { "id": "idJrEditor", "name": "Jr Editor", "backendName": "jr_editor", "displayName" : "jrEditorName"}
    ];

    readonly publishStatus = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];


    readonly formOptionMap : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    protected getTemplateHtml(): string{

        return  /*html*/`
            <div class="sub-header w-justify">

                ${ this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                    
                    <div class="multi-temp">${ this.dimensionGrouping.getHtmlBuild()}</div>
                    ${ this.brandsFilter.getHtmlBuild()} 
                    ${ this.brandSegmentsFilter.getHtmlBuild()}
                    ${ this.postInitiativesFilter.getHtmlBuild()}
                    ${ this.postIntentsFilter.getHtmlBuild()} 
                    ${ this.postContentTypesFilter.getHtmlBuild()} 
                    ${ this.networkCategoriesFilter.getHtmlBuild()}
                    ${ this.postPaymentCategorySystemFilter.getHtmlBuild()}
                    ${ this.primaryCategoriesFilter.getHtmlBuild()}
                    ${ this.srEditorsFilter.getHtmlBuild()}
                    ${ this.jrEditorsFilter.getHtmlBuild()} 
                    ${ this.datesFilter.getHtmlBuild()}
                    

                    
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: publishStatus">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div class="content-form-radio">
                        <div class="title" style="font-family:Lato, sans-serif">Form</div>
                        <form >
                            <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                            <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                            <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                            </div>
                        </form>
                    </div> 
                   
                </div>
             
                 
            </div>
            
            ${ this.validationsList.getHtmlBuild() }
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-dimensions"></div>
                   <div id="selected-brands"></div>
                   <div id="selected-brand-segments"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-systems"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-sr_editors"></div>
                   <div id="selected-jr_editors"></div>
                    <div id="selected-primary_categories"></div>
                    <div id="selected-senior_editors"></div>
                    <div id="selected-junior_editors"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-roi">Editorial Insights</h2>
                    <div>
                        <label class="toggle">
                            <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                            <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                            <div class="toggle-switch"></div>
                            <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                        </label>
                    </div>
                    
                    <div class="w-calculating" data-bind="visible:inProgress().length">
                        <div class="w-title">
                            <h3 class="icon i-settings">calculating...</h3>
                        </div>
                        <div class="calculating" data-bind="foreach: inProgress">
                            <div><strong data-bind="text:brand"></strong></span></div>
                        </div>
                        <div class="alert icon done">
                            <p>Updated data is being inserted.<br />Please refresh.</p>
                        </div>
                    </div>
                    
                </div>
                <div class="w-right">
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden }">Export</button>
                </div>
            </div>
                           
            <div class="w-list-results" id="list-results" style="padding-bottom: 200px">

                <table class="list-results">
                    <thead>
                    <tr>   
                        <!-- ko foreach: dynamicHeadersList -->
                            
                            <th class="align-right"><span class="icon list-sort-none align-right" data-bind="text: name, event: { click: $parent.onClickReorder.bind($data, backendName) }, css: { 'list-sort-desc': $parent.orderByAndDirection()== backendName + '_DESC', 'list-sort-asc': $parent.orderByAndDirection()== backendName + '_ASC' }" class="icon i-dropdown-simple"></span></th>
                        <!-- /ko -->     
                            
                        <th class="align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }" class="icon i-dropdown-simple">Art. Pub.</span></th>
                        <th class="align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }" class="icon i-dropdown-simple">Sess</span></th>
                        <th class="align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'sessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsPerArticle_ASC' }" class="icon i-dropdown-simple">Sess /Art.</span></th>

                        <th class="align-right">
                            <div  style="padding: 0;position: relative;" >

                                <span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'activeSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessions_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessions_ASC' }" class="icon i-dropdown-simple">
                                    Act. Sess
                                </span>

                                <div style="position: absolute;right: -2.4rem;top: 0;" class="w-tooltips-adv roi-tool auto-height short">
                                ${ this.toolTipActiveSess.getHtmlBuild()}
                                </div>
                            </div>
                        </th>

                        <th class="align-right">
                            <div  style="padding: 0;position: relative;" >
    
                                <span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'activeSessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='activeSessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='activeSessionsPerArticle_ASC' }" class="icon i-dropdown-simple">
                                    Act. Sess /Art.
                                </span>
                                
                                <div style="position: absolute;right: -2.4rem;top: 0;" class="w-tooltips-adv roi-tool auto-height short">
                                ${ this.toolTipActiveSessArt.getHtmlBuild()}
                                </div>
                            </div>
                        </th>
                        <th class="align-right">
                            <div  style="padding: 0;position: relative;" >
                                <span data-bind="event: { click: onClickReorder.bind($data, 'successRate') }, css: { 'list-sort-desc': orderByAndDirection()=='successRate_DESC', 'list-sort-asc': orderByAndDirection()=='successRate_ASC' }" class="icon list-sort-none i-dropdown-simpl align-right">
                                    Success Rate
                                </span>

                                <div style="position: absolute;right: -2.4rem;top: 0;" class="w-tooltips-adv roi-tool auto-height short">
                                    ${ this.toolTipSuccess.getHtmlBuild()}
                                </div>
                            </div>
                        </th>
                        <th class="align-right"> 
                            <div style=" padding: 0;position: relative;" >
                                <span data-bind="event: { click: onClickReorder.bind($data, 'failureRate') }, css: { 'list-sort-desc': orderByAndDirection()=='failureRate_DESC', 'list-sort-asc': orderByAndDirection()=='failureRate_ASC' }" class="icon list-sort-none i-dropdown-simple align-right">
                                    Failure Rate
                                </span>

                                <div style="position: absolute;right: -2.4rem;top: 0;" class="w-tooltips-adv roi-tool auto-height short">
                                ${ this.toolTipFailure.getHtmlBuild()}
                                </div>
                            </div>
                        </th>
                        <th  class="align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'pageviews') }, css: { 'list-sort-desc': orderByAndDirection()=='pageviews_DESC', 'list-sort-asc': orderByAndDirection()=='pageviews_ASC' }" class="icon i-dropdown-simple">PG</span></th>
                        <th  class="align-right"><span class="icon list-sort-none align-right" data-bind="event: { click: onClickReorder.bind($data, 'PGSPerSession') }, css: { 'list-sort-desc': orderByAndDirection()=='PGSPerSession_DESC', 'list-sort-asc': orderByAndDirection()=='PGSPerSession_ASC' }" class="icon i-dropdown-simple">PG/S</span></th>
                   </tr> 
                        
                       
                    </thead>
                    <tbody>
                    
                        <!-- ko foreach: editorialInsightsData -->
                        <tr>
                            <!-- ko foreach: $parent.dynamicHeadersList -->
                            
                                <!-- ko if: ($parentContext.$index() === 0 || $parents[1].editorialInsightsData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <!-- ko if: $parentContext.$index() === $parents[1].editorialInsightsData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].editorialInsightsData()[$parentContext.$index() + 1][backendName] != $parent[backendName]-->
                                        <td class="group single align-right"><span class="no-wrap" data-bind="text: $parent[backendName]"></span></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parentContext.$index() === $parents[1].editorialInsightsData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].editorialInsightsData()[$parentContext.$index() +1][backendName] != $parent[backendName]-->
                                        <td class="group first align-right"><span data-bind="text: $parent[backendName]"></span></td>
                                    <!-- /ko -->
                                <!-- /ko --> 
                                <!-- ko ifnot: ($parentContext.$index() === 0 || $parents[1].editorialInsightsData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <td class="group"><span></span></td>
                                <!-- /ko --> 
                            
                            <!-- /ko --> 
                            
                            <td class="align-right"><span class="no-wrap" data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right"><span data-bind="text: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') ? Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) : ''"></span></td>
                            <td class="align-right"><span data-bind="text: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') ? Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"></span></td>
                            <td class="align-right" data-bind="attr: {title: 'Success rate based on a blended sessions target of ' + Number(blendedTargetSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' sessions per published article.'}">

                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                    <span data-bind="text: (successRate != null && blendedTargetSessions != 0) ? Number(successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                <!-- /ko -->
                            </td>
                            <td class="align-right" style="padding-left: 0;padding-right: 0;" data-bind="attr: {title: 'Failure rate based on ' + (Number(isPassedCount) + Number(isFailureCount)) + ' articles out of ' + (Number(isPassedCount) + Number(isFailureCount) + Number(isPendingCount)) + '.'}, css: { 'is-empty': Number(isPendingCount) == 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-running': Number(isPendingCount) > 0 && (Number(isPassedCount) > 0 || Number(isFailureCount) > 0) }">
                            
                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                    <span style="margin-left: 2rem;" data-bind="text: (failureRate != null) ? Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                <!-- /ko -->
                            </td>
                            <td class="align-right" style="padding: 0.5rem 2rem 0.5rem 0;"><span data-bind="text: Number(pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(PGSPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                        </tr>
                        <!-- /ko -->   
                                         
                        <!-- ko foreach: editorialInsightsTotalsData -->
                        <tr class="total">
                            <!-- ko foreach: $parent.dynamicHeadersList -->
                                
                                <!-- ko if: ($parentContext.$index() === 0 || $parents[1].editorialInsightsData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <!-- ko if: $parentContext.$index() === $parents[1].editorialInsightsData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].editorialInsightsData()[$parentContext.$index() + 1][backendName] != $parent[backendName]-->
                                        <td class="align-right"><span class="no-wrap" data-bind="text: $parent[backendName]"></span></td>
                                    <!-- /ko -->
                                    <!-- ko ifnot: $parentContext.$index() === $parents[1].editorialInsightsData().length - 1 || $index() === $parents[1].dynamicHeadersList().length - 1 || $parents[1].editorialInsightsData()[$parentContext.$index() +1][backendName] != $parent[backendName]-->
                                        <td class="group first"><span data-bind="text: $parent[backendName]"></span></td>
                                    <!-- /ko -->
                                <!-- /ko --> 
                                <!-- ko ifnot: ($parentContext.$index() === 0 || $parents[1].editorialInsightsData()[$parentContext.$index() - 1][backendName] != $parent[backendName] || $index() === $parents[1].dynamicHeadersList().length - 1) -->
                                    <td class="group"><span></span></td>
                                <!-- /ko --> 
                            
                            <!-- /ko --> 
                            
                            <td class="align-right"><span class="no-wrap" data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right"><span data-bind="text: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') ? Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) : ''"></span></td>
                            <td class="align-right"><span data-bind="text: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') ? Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"></span></td>
                            <td class="align-right" data-bind="attr: {title: 'Success rate based on a blended sessions target of ' + Number(blendedTargetSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' sessions per published article.'}">

                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                    <span data-bind="text: (successRate != null && blendedTargetSessions != 0) ? Number(successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                <!-- /ko -->
                            </td>
                            <td class="align-right" style="padding-right: 0" data-bind="attr: {title: 'Failure rate based on ' + (Number(isPassedCount) + Number(isFailureCount)) + ' articles out of ' + (Number(isPassedCount) + Number(isFailureCount) + Number(isPendingCount)) + '.'}, css: { 'is-empty': Number(isPendingCount) == 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-running': Number(isPendingCount) > 0 && (Number(isPassedCount) > 0 || Number(isFailureCount) > 0) }">
                            
                                <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                    <span data-bind="text: (failureRate != null) ? Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                <!-- /ko -->
                            </td>
                            <td class="align-right" style="padding: 0.5rem 2rem 0.5rem 0;"><span data-bind="text: Number(pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td class="align-right"><span data-bind="text: Number(PGSPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                        </tr>
                        <!-- /ko -->
                            
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('editorialInsights');

        this.dimensionGrouping = new multipleSelector_template("dimensionGrouping", this.getTemplateViewModel(), this.caller);
        this.dimensionGrouping.setLabel("Dimensions");
        this.dimensionGrouping.setFilterContainerClass('margin-neg');
        this.dimensionGrouping.setTagContainerId('selected-dimensions');
        this.dimensionGrouping.setTagContainerCaption('Selected dimensions:');
        this.dimensionGrouping.setItems(editorialInsights_template.dimensionGroupingItems);
        this.dimensionGrouping.setSelectAllEnabled(false);
        this.dimensionGrouping.setDisplaySelectionOrder(true);

        // In order for preset filters to work with this report, we must make sure to not overwrite the dimensionGrouping if it's already set in the URL
        if (window.location.href.search(/dimensionGrouping/gi) == -1){

            this.dimensionGrouping.getTemplateViewModel().selectedItems(["dateData"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"dateData"}]);
            this.getTemplateViewModel().groupingDimensionsSelected.push({ "id": "dateData",  "name": "Day", "backendName": "Day", "displayName" : "dateData"});
        }

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.brandSegmentsFilter = new multipleSelector_template("brandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.brandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.brandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.brandSegmentsFilter.setLabel("segments");
        this.brandSegmentsFilter.setLogoEnabled(false);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Senior Editor");
        this.srEditorsFilter.setTagContainerId('selected-senior_editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Senior Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Junior Editor");
        this.jrEditorsFilter.setTagContainerId('selected-junior_editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Junior Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{
            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportEditorialInsightsDataCsv = new exportDataCsv();


        let toolTipActiveSessContent = `
            <p>Active Sessions represents all active sessions on the day, not limited to only articles published on that day.</p>
        `;
        this.toolTipActiveSess = new infoButton_template('toolTipActiveSess', this.getTemplateViewModel(), this.caller)
        this.toolTipActiveSess.setTitle('ACTIVE SESS');
        this.toolTipActiveSess.setContent(toolTipActiveSessContent);

        let toolTipActiveSessArtContent = `
            <p>Active Sessions/Article represents all active sessions on the day, not limited to only articles published on that day.</p>
        `;
        this.toolTipActiveSessArt = new infoButton_template('toolTipActiveSessArt', this.getTemplateViewModel(), this.caller)
        this.toolTipActiveSessArt.setTitle('ACTIVE SESS /ART.');
        this.toolTipActiveSessArt.setContent(toolTipActiveSessArtContent);

        let toolTipFailureContent = `
            <p>Failure Rate is based on the count of articles which fall below the established session threshold within the initial 30 days of publication.</p>
            <p>An article that is less than 30 days old will be considered pending.</p>
            <p>Sessions are attributed to articles if that article was the ‘Landing Page’ (i.e. first visited page) of that session.</p>
        `;
        this.toolTipFailure = new infoButton_template('toolTipFailure', this.getTemplateViewModel(), this.caller)
        this.toolTipFailure.setTitle('Failure Rate');
        this.toolTipFailure.setContent(toolTipFailureContent);

        let toolTipSuccessContent = `
            <p>Success Rate is calculated by dividing the active sessions by the blended target sessions.</p>
            <p>Active sessions are sessions which happened for an article which is less than 30-days old.</p>
            <p>Blended Target Sessions is the sum of the session targets for that month (including the content type exceptions, if this exists) for each published article.</p>
        `;
        this.toolTipSuccess = new infoButton_template('toolTipSuccessContent', this.getTemplateViewModel(), this.caller)
        this.toolTipSuccess.setTitle('Success Rate');
        this.toolTipSuccess.setContent(toolTipSuccessContent);
    }

    protected getTemplateName(): string{

        return "editorialInsights_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            orderBy                                    : ko.observable("Day"),
            orderByDirection                           : ko.observable("ASC"),
            orderByAndDirection                        : ko.observable("Day_ASC"),
            editorialInsightsData                      : ko.observableArray([]),
            editorialInsightsTotalsData                : ko.observableArray([]),
            inProgress                                 : ko.observableArray(),
            groupingDimensionsSelected                 : ko.observableArray([]),
            dynamicHeadersList                         : ko.observableArray([]),
            exportButtonHidden                         : ko.observable(1),
            publishStatus                              : ko.observableArray([]),
            publishStatusSelected                      : ko.observable("all"),
            formOptions                                : ko.observableArray([]),
            formOptionSelected                         : ko.observable("all"),
            trafficSource                              : ko.observable(2),
            onClickReorder                             : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); },
            exportData                                 : function(){ huit_neuf_this.exportData(huit_neuf_this); },
            onPublishStatusChange                      : function(data){ huit_neuf_this.onPublishStatusChange(); },
            onFormOptionChange                         : function(data) {huit_neuf_this.onFormOptionChange(data); },
            onToggleTrafficSource                      : function(data, event){ huit_neuf_this.onToggleTrafficSource(data, event);},
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            brandSegments: this.getTemplateViewModel().brandSegmentsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
            namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorName: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorName: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            dimensionGroupings: this.getTemplateViewModel().groupingDimensionsSelected(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            publishStatus: this.getTemplateViewModel().publishStatusSelected(),
            formOption: this.getTemplateViewModel().formOptionSelected(),
            trafficSource: this.getTemplateViewModel().trafficSource(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){
        this.datesFilter.buildCalendar();
    }

    public initiateDimensionSelectTag(){
        this.dimensionGrouping.setTags(["dateData"], editorialInsights_template.dimensionGroupingItems);
    }

    public setBrandFilterItems(departments){
        let groups = [];
        for ( let department of departments){

            let brands = [];
            for( let brand of department.brands){

                if(brand.segments.length > 0){

                    for(let segment of brand.segments){

                        brands.push(segment);
                    }
                }
                else{

                    brands.push(brand);
                }
            }

            let group = {"name" : department.name, "logo" : department.logo, "items" : brands};
            groups.push(group);
        }
        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel('Brands');
    }

    public setBrandSegments(brandSegments){

        let groups = [];
        for (let brand of brandSegments){

            let segments = [];
            for( let segment of brand.segments){

                segments.push(segment);
            }

            let group = {"name" : brand.name, "items" : segments};
            groups.push(group);
        }
        this.brandSegmentsFilter.setMultiSectionItems(groups);
        this.brandSegmentsFilter.setLabel('Segments');
    }


    public setPostContentTypesGroupFilterItems(){

        this.getTemplateViewModel().formOptions(this.formOptionMap);
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }


    public setTemplateFromTrafficSource(trafficSource) {

        this.getTemplateViewModel().trafficSource(trafficSource);
    }

    public setPostInitiativesFilterItems(items){
        for (let item of items){
            item['name'] = item['initiative'];
        }
        this.postInitiativesFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){
        for (let item of items){
            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){
            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){
            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        this.jrEditorsFilter.setItems(items);
    }

    public setPublishStatusItems(){
        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setEditorialInsightsData(editorialInsightsData){

        this.setDynamicHeaders();
        this.showExportButton();
        this.getTemplateViewModel().editorialInsightsData(editorialInsightsData.editorialInsightsDataPerDimensionGroupings);

        let reportTotalsData = [];
        reportTotalsData.push(editorialInsightsData.totalEditorialInsightsData);
        this.getTemplateViewModel().editorialInsightsTotalsData(reportTotalsData);

    }

    public setInProgress(items){

        this.getTemplateViewModel().inProgress(items);
    }

    public onClickReorder(value, data, event){
        if(typeof data.orderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.hideExportButton();
        this.caller.listReorder();
    }

    public validateOrderBy(){
        let orderByChoosen = this.getTemplateViewModel().orderBy();

        // @ts-ignore
        let orderByIsDimension = editorialInsights_template.dimensionGroupingItems.find(i => i.backendName === orderByChoosen);

        if(orderByIsDimension != null){
            let orderByInSelectedDimension = this.getTemplateViewModel().groupingDimensionsSelected().find(i => i.backendName === orderByChoosen);

            if(typeof orderByInSelectedDimension === 'undefined'){

                this.getTemplateViewModel().orderBy(null);
                this.getTemplateViewModel().orderByAndDirection(null);
            }
        }
    }

    private setDynamicHeaders() {
        this.getTemplateViewModel().dynamicHeadersList([]);
        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {
            for (let dimensionItem of editorialInsights_template.dimensionGroupingItems) {
                if (selectedDimensionItem === dimensionItem.id) {
                    this.getTemplateViewModel().dynamicHeadersList.push(dimensionItem);
                }
            }
        }
    }

    public resetDefaultDimensionFilters(){
        if(this.getTemplateViewModel().dimensionGrouping.selectedItems().length === 0){
            this.dimensionGrouping.getTemplateViewModel().selectedItems(["dateData"]);
            this.dimensionGrouping.setSelectedItemsOrderBySelection([{"id":"dateData"}]);
        }
    }

    public setSelectDimensionsObjects(){
        this.getTemplateViewModel().groupingDimensionsSelected([]);
        for (let selectedDimensionItem of this.getTemplateViewModel().dimensionGrouping.selectedItemsOrderBySelection()) {
            for (let dimensionItem of editorialInsights_template.dimensionGroupingItems) {
                if (selectedDimensionItem === dimensionItem.id) {
                    this.getTemplateViewModel().groupingDimensionsSelected.push(dimensionItem);
                }
            }
        }
    }

    private exportData(obj){

        let exportData = [];

        for (let exportDataRow of this.getTemplateViewModel().editorialInsightsData()) {

            exportData.push(this.getFormatedExportRow(exportDataRow));
        }

        for (let exportDataRow of this.getTemplateViewModel().editorialInsightsTotalsData()) {

            exportData.push(this.getFormatedExportRow(exportDataRow));
        }

        let fileName = "editorialInsights_data_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportEditorialInsightsDataCsv.exportToCsv(fileName, exportData);
    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];

        for (let dynamicHeadersList of this.getTemplateViewModel().dynamicHeadersList()) {

            exportDataViewRow[dynamicHeadersList.name] = exportDataRow[dynamicHeadersList.backendName];
        }

        exportDataViewRow["Article Count"] = Number(exportDataRow.articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})
        exportDataViewRow["Article Published"] = Number(exportDataRow.articlePublished).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})
        exportDataViewRow["Article Republished"] = Number(exportDataRow.articleRePublished).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})
        exportDataViewRow["Sess"] = Number(exportDataRow.sessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Sess/Art."] = Number(exportDataRow.sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Active Sess/Art."] = (this.getTemplateViewModel().publishStatusSelected() == 'publish' || this.getTemplateViewModel().publishStatusSelected() == 'all') ? Number(exportDataRow.activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '';
        exportDataViewRow["Success Rate"] = ((this.getTemplateViewModel().publishStatusSelected() == 'publish' || this.getTemplateViewModel().publishStatusSelected() == 'all') && exportDataRow.successRate != null && exportDataRow.blendedTargetSessions != 0) ? Number(exportDataRow.successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : '';
        exportDataViewRow["Failure Rate"] = ((this.getTemplateViewModel().publishStatusSelected() == 'publish' || this.getTemplateViewModel().publishStatusSelected() == 'all') && exportDataRow.failureRate != null) ? Number(exportDataRow.failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : '';
        exportDataViewRow["PG"] = Number(exportDataRow.pageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["PG/S"] = Number(exportDataRow.PGSPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        return exportDataViewRow;
    }

    public hideExportButton(){
        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){
        this.getTemplateViewModel().exportButtonHidden(0);
    }

    private onPublishStatusChange(){
        this.caller.getListData();
    }

    private onFormOptionChange(selectedRevenueOption){
        this.caller.getListData();
    }

    private onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            //sentinel
            this.getTemplateViewModel().trafficSource(1);
        }else {

            //GA4
            this.getTemplateViewModel().trafficSource(2);
        }

        this.caller.getListData();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, params['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['postPaymentCategorySystems']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['idPrimaryCategories'], params['namePrimaryCategories']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorName']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorName']);

        if(typeof params['dimensionGroupings'] !== 'undefined'){

            let dimensionGroupingIds = [];

            for (let dimensionGrouping of params['dimensionGroupings']){

                dimensionGroupingIds.push(dimensionGrouping.id);
            }

            this.presetFilter.setMultiSelectorPresetFilters(this.dimensionGrouping, dimensionGroupingIds);
            this.getTemplateViewModel().groupingDimensionsSelected(params['dimensionGroupings']);
        }

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        // Publishing type custom filter
        if(typeof params['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['publishStatus']);
        }
        
        if (typeof params['filter']['formOption'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['filter']['formOption']);
        }
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/editorialInsights_template.ts